import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import Link from 'next/link'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import { fetchAPI } from '../../lib/blog/api'
import Seo from '../../components/blog/Seo'
import BlogImage from '../../components/blog/Image'
import styles from '../../styles/components/BlogArticle.module.css'
import SubscribeViaEmailModal from '../../components/SubscribeViaEmailModal'

const Article = ({ article }) => {
  const seo = {
    metaTitle: article.attributes.title,
    metaDescription: article.attributes.description,
    shareImage: article.attributes.image,
    schema: article.attributes.schema,
    article: true
  }

  return (
    <>
      <Seo seo={seo} />

      <div className='mb-lg-5 mb-md-4 mb-3 bg-warning text-center text-white br-3'>
        <Row>
          <Col xs={12}>
            <div className='p-3 p-md-4 p-lg-5'>
              <div>
                <Link
                  href='/resources'
                  legacyBehavior
                >
                  <span
                    className='fs-5 opacity-75'
                    style={{ cursor: 'pointer' }}
                  >Resources</span>
                </Link>
              </div>
              <h1 className='fw-semibold mt-2'>
                {article.attributes.title}
              </h1>
            </div>
          </Col>
        </Row>
      </div>

      <Row className='mb-5'>
        <Col
          xs={12} md={3}
          className='mb-3 mb-md-0'
        >
          <div
            className='br-3 overflow-hidden'
            style={{ maxHeight: '300px' }}
          >
            <BlogImage image={article.attributes.image} />
          </div>
        </Col>
        <Col xs={12} md={9}>
          <div className='ps-lg-4 ps-md-3'>
            <div
              className={`fs-5 ${styles.article}`}
              style={{ lineHeight: '1.7' }}
            >
              <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                {article.attributes.content}
              </ReactMarkdown>
            </div>
            <div className='p-3 px-4 bg-light mt-4 br-3'>
              {article.attributes.published_at}
            </div>
          </div>
        </Col>
      </Row>

      <SubscribeViaEmailModal />
    </>
  )
}

export async function getStaticPaths () {
  const articlesRes = await fetchAPI('/articles', { fields: ['slug'] })

  if (!articlesRes) {
    return {
      paths: [],
      fallback: false
    }
  }

  return {
    paths: articlesRes.data.map((article) => ({
      params: {
        slug: article.attributes.slug
      }
    })),
    fallback: 'blocking'
  }
}

export async function getStaticProps ({ params }) {
  const articlesRes = await fetchAPI('/articles', {
    filters: {
      slug: params.slug
    },
    populate: ['image']
  })

  if (!articlesRes || !articlesRes?.data[0]) {
    return {
      redirect: {
        destination: '/resources'
      }
    }
  }

  return {
    props: {
      article: articlesRes.data[0]
    },
    revalidate: 60 * 60 * 24
  }
}

export default Article
